<div #sdkmessage class="sdk-message" [ngClass]="{ show: showMessage }" [ngStyle]="{ visibility: (showMessage) ? 'visible' : 'hidden' }" [style]="style" (click)="clearMessage()" (mouseover)="stopTimer()" (mouseout)="startTimer()">
    <div class="message" [innerHTML]="_message"></div>
</div>
